module.exports = __webpack_public_path__ + "files/a8f524ba33b762a95899807553cb2e5a.png";